import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import YouTubeIcon from '@mui/icons-material/YouTube';

import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import { InstagramIcon, LinkedInIcon } from '../../styles/icons';
import './AboutMe.scss';

const AboutMe = props => {
  const { provider } = props;
  // const [bioIsTruncated, setBioIsTruncated] = useState(true);
  // const bioLength = 450;
  if (!provider.bio) return <></>;
  if (props?.aboutMeType === 'funFacts' && !provider?.fun_facts) return <></>
  let html = (props?.aboutMeType === 'funFacts' ? provider?.fun_facts : provider.bio)
    .replace(/<p>{0,4}\s<\/p>/g, '')
    .replace(/<p>\&nbsp;<\/p>/g, '')
    .replace(/<p><br><\/p>/g, '');
  console.log('HTML', html);
  return (
    <CustomBox borderless className='AboutMeComponent'>
      <CustomSubheader>
        {props?.aboutMeType === 'funFacts' ? 'Fun Facts' : 'About'}
      </CustomSubheader>
      {/*{
          bioIsTruncated
          ? <>
            <Typography variant='body1' style={{color: '#555555'}}>
              {truncate(provider.bio, {length: bioLength, appendString: '...'})}
              {
                provider.bio.length > bioLength
                ? <Button onClick={() => setBioIsTruncated(false)}>
                    Read More
                  </Button>
                : <></>
              }
            </Typography>
          </>
          : <Typography variant='body1' style={{color: '#555555'}}>
            {provider.bio}
            </Typography>
        }*/}

      <Box className='AboutMe__content'>
        <Typography variant='paragraphSmall' color='text.primary' letterSpacing='0.35px'>
          <span 
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </Typography>
      </Box>
      {props?.aboutMeType !== 'funFacts' && 
        <Stack direction='row' alignItems='center' className='AboutMe__social-network'>
          {
            provider.instagramUrl &&
            <Link underline="hover" variant="body" target='_blank' href={provider.instagramUrl}>
              <Stack direction='row' alignItems='center'>
                <InstagramIcon />{' '}
                <Typography variant='paragraphSmall' color='text.blue'>
                  Instagram
                </Typography>
              </Stack>
            </Link>
          }
          {
            provider.linkedInUrl &&
            <Link underline="hover" variant="body" target='_blank' href={provider.linkedInUrl}>
              <Stack direction='row' alignItems='center'>
                <LinkedInIcon />{' '}
                <Typography variant='paragraphSmall' color='text.blue'>
                  LinkedIn
                </Typography>
              </Stack>
            </Link>
          }
          {
            provider.youtube_url &&
            <Link underline="hover" variant="body" target='_blank' href={provider.youtube_url}>
              <Stack direction='row' alignItems='center'>
                <YouTubeIcon />{' '}
                <Typography variant='paragraphSmall' color='text.blue'>
                  YouTube
                </Typography>
              </Stack>
            </Link>
          }
        </Stack>
      }
    </CustomBox>
  );
};

export default AboutMe;
